__turbopack_context__.v({
  "answer": "external-chat-module__vpPFWa__answer",
  "assistant": "external-chat-module__vpPFWa__assistant",
  "chat": "external-chat-module__vpPFWa__chat",
  "composer": "external-chat-module__vpPFWa__composer",
  "copilotMark": "external-chat-module__vpPFWa__copilotMark",
  "prompt": "external-chat-module__vpPFWa__prompt",
  "response": "external-chat-module__vpPFWa__response",
  "responseActions": "external-chat-module__vpPFWa__responseActions",
  "sources": "external-chat-module__vpPFWa__sources",
  "tool": "external-chat-module__vpPFWa__tool",
  "transcript": "external-chat-module__vpPFWa__transcript",
});
